import moment from 'moment';

export function buildRegisterBookingPayload(booking, session) {
  return {
    ...booking,
    UserAccessToken: session.userAccessToken,
    DeviceAccessToken: session.deviceAccessToken,
    RegisterType: 'Agent',
    ArrivalDate: moment(booking.ArrivalDate).format('YYYY-MM-DD'),
    DepartureDate: moment(booking.DepartureDate).format('YYYY-MM-DD')
  };
}
